module.exports = __webpack_public_path__ + "assets/icons/calendar-cross-0f1a.svg";